export default __webpack_public_path__ + "static/media/fnac.e8951cce.png";